import type { RouteRecordRaw } from 'vue-router';

/**
 * Vendors (Furnitorët) — the buy-side view of the shared partner registry.
 * Reuses the Clients pages; `meta.role: 'supplier'` switches them to filter and
 * create vendors (is_supplier) instead of clients.
 */
const PartnerListPage = () => import('@/features/customers/pages/CustomersListPage.vue');
const PartnerFormPage = () => import('@/features/customers/pages/CustomerFormPage.vue');

export const vendorsRoutes: RouteRecordRaw[] = [
  {
    path: 'vendors',
    name: 'vendors',
    component: PartnerListPage,
    meta: { title: 'Vendors', requiresAuth: true, role: 'supplier', permission: 'view_suppliers' },
  },
  {
    path: 'vendors/new',
    name: 'vendors.create',
    component: PartnerFormPage,
    meta: { title: 'New vendor', requiresAuth: true, role: 'supplier' },
  },
  {
    path: 'vendors/:id',
    name: 'vendors.show',
    component: PartnerFormPage,
    meta: { title: 'Vendor', requiresAuth: true, role: 'supplier' },
  },
];
